var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"collapse-wrapper-toggle",class:{
    'collapse-wrapper-toggle--expanded': _vm.expanded,
    'collapse-wrapper-toggle--bordered': _vm.bordered,
    [`collapse-wrapper-toggle--${_vm.type}`]: true,
  },on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_c('span',{staticClass:"collapse-wrapper-toggle__text"},[_vm._t("default")],2),_vm._v(" "),_c('span',{staticClass:"cfa cfa-chevron-down"})])
}
var staticRenderFns = []

export { render, staticRenderFns }